export default __webpack_public_path__ + "static/media/Type 7.65570794.jpg";